package top.wcpe.allincore.dsl.ir.model.internal

/**
 * 只读有序 Map 视图（模块内共享工具）。
 *
 * 复刻原 Java `Collections.unmodifiableMap(new LinkedHashMap<>(...))` 语义：
 * - **保序**：委托构造期传入的保序 [backing]（约定为 LinkedHashMap），迭代顺序即插入序。
 * - **只读**：继承 Kotlin [AbstractMap]（只暴露只读契约、不实现可变方法），
 *   Java 侧对其调用 put / remove / clear 等会抛 [UnsupportedOperationException]，
 *   Java 调用方无法借 getter 返回值篡改 IR 内部状态。
 *
 * equals / hashCode / toString 均委托 [backing]，与所包裹 Map 完全一致。
 *
 * commonMain 无 `java.util.Collections`，故用本类等价替代，`internal` 仅限 dsl-ir 内部使用。
 *
 * @param backing 已在构造方保序拷贝好的底层 Map（本类不再拷贝，调用方负责传入独立副本）。
 */
internal class ReadOnlyOrderedMap<K, V>(
    private val backing: Map<K, V>,
) : AbstractMap<K, V>() {

    override val entries: Set<Map.Entry<K, V>>
        get() = backing.entries
}
